import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row} from 'antd';
import icp_img from '../assets/ICP.jpeg';

class ICP extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const bg = this.props.bg || 'transparent';
        return (
            <Row type="flex" justify="center" align="middle" style={{width: "100%", height: 28, backgroundColor: bg}}>
                <a style={{color: "#ffffff"}} href={icp_img} target="_blank">ICP许可证 粤B1.B2-20051036 </a>
            </Row>
        );
    }
}
ICP.propTypes = {
    bg: PropTypes.string
}

export default ICP;



// WEBPACK FOOTER //
// ./src/components/ICP.jsx